export const COMPOSER_SHORTCUTS = {
  SAVE_DRAFT: 'mod+S',
  SCHEDULE_POST: 'mod+Enter',
  UPDATE_POST: 'mod+Enter',
  SCHEDULE_POST_AND_CREATE_NEW: 'mod+Shift+Enter',
} as const
